<template lang="pug">
section#contact.section.page-section.top-section
  .header(:style="`background-image:url(${backgroundUrl})`")
    .container
      h1.is-size-1 We&rsquo;d love to hear from you
  section.section.page-section
    .container
      .columns
        .column.is-two-thirds-desktop
          .content.mobile-margin
            h3 Questions or comments?
            p Please fill out the following form and we&rsquo;ll get back with you as soon as we can.
            form(@submit.prevent="submit")
              b-field.is-required(
                label="Name"
                :type="errors.has('name') ? 'is-danger' : ''"
                :message="errors.has('name') ? errors.first('name') : ''"
                expanded
              )
                b-input(
                  name="name"
                  v-model="contact.name"
                  v-validate="'required'"
                )
              b-field(grouped)
                b-field.is-required(
                  label="Email Address"
                  :type="errors.has('email') ? 'is-danger' : ''"
                  :message="errors.has('email') ? errors.first('email') : ''"
                  expanded
                )
                  b-input(
                    type="email"
                    name="email"
                    icon="email-outline"
                    v-model="contact.email"
                    v-validate="'required|email'"
                    data-vv-delay="1000"
                  )
                b-field(label="Phone Number" expanded)
                  phone-field(type="text" v-model="contact.phone_number")
              b-field.is-required(
                label="Message (1000 characters max)"
                :type="errors.has('message') ? 'is-danger' : ''"
                :message="errors.has('message') ? errors.first('message') : ''"
              )
                b-input(
                  type="textarea"
                  name="message"
                  rows="10"
                  v-model="contact.message"
                  v-validate="{ required: true, max: settings.messageMax }"
                )
              .message-length-preview.is-size-7.has-text-grey(v-if="contact.message && contact.message.length > 0") {{ contact.message.length }}/{{ settings.messageMax }}
              .form-controls
                button.button.is-primary.is-medium(
                  type="submit"
                  :class="{ 'is-loading': settings.submitting }"
                ) Submit
        .column.is-one-third-desktop
          about-account.mobile-margin
</template>

<script>
import { mapGetters } from 'vuex';
import { HTTP } from '@/utils/http';
import cloudinary from 'cloudinary-core';
import AboutAccount from '@/components/accounts/AboutAccount.vue';
import PhoneField from '@/components/events/PhoneField.vue';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'contact-page',
  components: {
    AboutAccount,
    PhoneField,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      page: getterTypes.GET_PAGE,
    }),
    backgroundUrl() {
      if (!this.image) return null;
      let opts = {};
      if (this.isMobile) {
        opts = {
          width: 600,
          height: 600,
          effect: 'blur:1000',
          quality: 'auto',
          fetch_format: 'auto',
          crop: 'thumb',
          opacity: 60,
          format: 'png',
        };
      } else {
        opts = {
          width: 1200,
          height: 700,
          effect: 'blur:700',
          quality: 'auto',
          fetch_format: 'auto',
          crop: 'fill',
          opacity: 50,
          format: 'png',
        };
      }
      return this.cloudinary.url(this.image.cl_id, opts);
    },
  },
  async created() {
    this.cloudinary = cloudinary.Cloudinary.new({
      cloud_name: process.env.VUE_APP_CLOUDINARY_CLOUD_NAME,
    });
    const { data } = await HTTP.get(`/accounts/${this.account.id}/sub_page_gallery`, {});
    this.image = data.data.images[0];
  },
  data() {
    return {
      cloudinary: null,
      contact: {},
      image: null,
      settings: {
        messageMax: 1000,
        submitting: false,
      },
    };
  },
  methods: {
    async submit() {
      const valid = await this.$validator.validateAll();
      if (valid && !this.settings.submitting) {
        this.settings.submitting = true;
        const response = await HTTP.post('/contacts', this.contact);
        this.$dialog.alert({
          title: 'Message submitted',
          message: response.data.message,
          type: 'is-primary',
          onConfirm: () => {
            this.contact = {};
            this.$validator.reset();
          },
        });
        this.settings.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss">
#contact {
  .header {
    @include hero;
  }
  .is-grouped {
    margin-bottom: 0;
  }
  .content {
    background-color: white;
    padding: 1.5rem;
  }
  label.label {
    font-weight: normal;
    color: $grey;
  }
  .message-length-preview {
    position: relative;
    top: -14px;
    text-align: right;
  }
}
@media (max-width: $tablet) {
  #contact {
    .header {
      background-size: cover;
      background-attachment: inherit;
    }
    .field.is-grouped {
      flex-flow: column;
      margin-bottom: 1.25rem;
      .field:first-child {
        margin-right: 0;
      }
    }
    .form-controls {
      .button {
        width: 100%;
      }
    }
  }
}
</style>
